import { IHttpApi } from '@cian/http-api/shared/http';
import { ILogger } from '@cian/logger';

interface IRequestParams {
  code: string;
  uuid: string;
}

interface IResponseParams {
  ok: boolean;
  isNewUser?: boolean;
  error?: string;
}

export const fetchOtp = async (
  { httpApi, logger }: { httpApi: IHttpApi; logger: ILogger },
  parameters: IRequestParams,
) => {
  try {
    const response = await postOtp(httpApi, parameters);

    return response;
  } catch (error) {
    logger.error(error, {
      domain: 'fetchOtp',
    });

    return { error: 'Возникла ошибка при отправке кода', ok: false };
  }
};

export async function postOtp(httpApi: IHttpApi, params: IRequestParams): Promise<IResponseParams> {
  const { responseBody } = await httpApi.httpRequest({
    method: 'POST',
    headers: [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
    ],
    body: JSON.stringify(params),
    uri: {
      scheme: 'https',
      host: 'fin.cian.ru',
      path: '/authorization-service/code',
    },
    withCredentials: true,
  });

  const result: IResponseParams = JSON.parse(responseBody);

  return result;
}
